<template>
    <div class="sk__listPage sk__listPage_desktop">
        <div class="sk__listPage-description">
            <div class="sk__listPage-description-item elem w100"></div>
            <div class="sk__listPage-description-item elem w100"></div>
            <div class="sk__listPage-description-item elem w100"></div>
            <div class="sk__listPage-description-item elem w70"></div>
            <div class="sk__listPage-description-item elem w40"></div>
        </div>
        <div class="sk__listPage-control">
            <div class="sk__listPage-control-left">
                <div class="sk__listPage-control-left-search elem"></div>
                <div class="sk__listPage-control-left-button elem"></div>
            </div>
            <div class="sk__listPage-control-sorting elem"></div>
        </div>
    </div>
    <div class="sk__listPage sk__listPage_mobile">
        <div class="sk__listPage-description">
            <div class="sk__listPage-description-item elem w100"></div>
            <div class="sk__listPage-description-item elem w70"></div>
            <div class="sk__listPage-description-item elem w40"></div>
        </div>
        <div class="sk__listPage-buttonView elem"></div>
        <div class="sk__listPage-buttonMap elem"></div>
        <div class="sk__listPage-control">
            <div class="sk__listPage-control-search elem"></div>
            <div class="sk__listPage-control-sorting elem"></div>
        </div>
    </div>
</template>

<script>
export default {
};
</script>

<style scoped lang="less">
@import "theme/moydom/less/variables.less";

.sk__listPage {
    &-description {
        max-width: 780px;

        &-item {
            height: 16px;
            border-radius: 20px;
            margin-bottom: 15px;
        }
    }

    &-control {
        display: flex;
        justify-content: space-between;
        margin-top: 67px;

        &-left {
            display: flex;
            gap: 25px;
            width: 100%;

            &-search {
                width: 45%;
                border-radius: 6px;
                height: 40px;
            }

            &-button {
                height: 40px;
                border-radius: 6px;
                width: 10%;
            }
        }

        &-sorting {
            border-radius: 6px;
            height: 40px;
            width: 10%;
        }
    }

    &-buttonView {
        margin-top: 14px;
        width: 80px;
        height: 20px;
        border-radius: 20px;
    }

    &-buttonMap {
        border-radius: 6px;
        width: 170px;
        height: 40px;
        margin-top: 30px;
    }

    &_desktop {
        @media (max-width: @screen-xs) {
            display: none;
        }
    }

    &_mobile {
        display: none;
        @media (max-width: @screen-xs) {
            display: block;
        }
    }
}

.w100 {
    width: 100%;
}

.w70 {
    width: 70%;
}

.w40 {
    width: 40%;
}

.elem {
    background: #EAEDF0;
    position: relative;
    overflow: hidden;

    &::after {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        transform: translateX(-100%);
        background: linear-gradient(90deg,
        transparent 0%,
        #c3c3c361 30%,
        transparent 100%);
        animation: load 2s infinite;
        content: '';
    }
}

@keyframes load {
    100% {
        transform: translateX(100%);
    }
}

</style>
